<template>
  <div v-if="editor" class="custom-editor-header" :class="{'small-header':small}">
    <div class="custom-editor-header-holder">
      <button @click="editor.chain().focus().toggleBold().run()" :disabled="!editor.can().chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }" title="bold">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_10535)"><path d="M8 11H12.5C13.163 11 13.7989 10.7366 14.2678 10.2678C14.7366 9.79893 15 9.16304 15 8.5C15 7.83696 14.7366 7.20107 14.2678 6.73223C13.7989 6.26339 13.163 6 12.5 6H8V11ZM18 15.5C18 16.0909 17.8836 16.6761 17.6575 17.2221C17.4313 17.768 17.0998 18.2641 16.682 18.682C16.2641 19.0998 15.768 19.4313 15.2221 19.6575C14.6761 19.8836 14.0909 20 13.5 20H6V4H12.5C13.381 4.00004 14.2425 4.25865 14.9779 4.74378C15.7132 5.2289 16.29 5.9192 16.6367 6.72907C16.9834 7.53894 17.0847 8.43276 16.9282 9.29969C16.7716 10.1666 16.3641 10.9685 15.756 11.606C16.4386 12.0013 17.0053 12.5692 17.3992 13.2526C17.7931 13.9361 18.0003 14.7112 18 15.5ZM8 13V18H13.5C14.163 18 14.7989 17.7366 15.2678 17.2678C15.7366 16.7989 16 16.163 16 15.5C16 14.837 15.7366 14.2011 15.2678 13.7322C14.7989 13.2634 14.163 13 13.5 13H8Z" fill="#212121"/></g><defs><clipPath id="clip0_2_10535"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      <button @click="editor.chain().focus().toggleItalic().run()" :disabled="!editor.can().chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }" title="italic">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_9659)"><path d="M15 20H7V18H9.927L12.043 6H9V4H17V6H14.073L11.957 18H15V20Z" fill="#212121"/></g><defs><clipPath id="clip0_2_9659"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      <button @click="editor.chain().focus().toggleStrike().run()" :disabled="!editor.can().chain().focus().toggleStrike().run()" :class="{ 'is-active': editor.isActive('strike') }" title="strike">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_9787)"><path d="M17.154 14C17.384 14.516 17.5 15.09 17.5 15.72C17.5 17.062 16.976 18.112 15.929 18.867C14.88 19.622 13.433 20 11.586 20C9.946 20 8.323 19.619 6.716 18.856V16.6C8.236 17.477 9.791 17.916 11.382 17.916C13.933 17.916 15.212 17.184 15.221 15.719C15.2263 15.422 15.1716 15.1269 15.0603 14.8515C14.9489 14.5761 14.7832 14.3259 14.573 14.116L14.453 13.999H3V11.999H21V13.999H17.154V14ZM13.076 11H7.629C7.45383 10.8403 7.29289 10.6656 7.148 10.478C6.716 9.92 6.5 9.246 6.5 8.452C6.5 7.216 6.966 6.165 7.897 5.299C8.83 4.433 10.271 4 12.222 4C13.693 4 15.101 4.328 16.444 4.984V7.136C15.244 6.449 13.929 6.106 12.498 6.106C10.018 6.106 8.779 6.888 8.779 8.452C8.779 8.872 8.997 9.238 9.433 9.551C9.869 9.864 10.407 10.113 11.046 10.301C11.666 10.481 12.343 10.715 13.076 11V11Z" fill="#212121"/></g><defs><clipPath id="clip0_2_9787"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      <span class="separator-line"></span> 
      
      <!--<button @click="editor.chain().focus().unsetAllMarks().run()">
        clear marks
      </button>
      <button @click="editor.chain().focus().clearNodes().run()">
        clear nodes
      </button>-->
      <button @click="editor.chain().focus().setParagraph().run()" :class="{ 'is-active': editor.isActive('paragraph') }" title="paragraph">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_53_22)"><path d="M10 4.99998V17.5H8.33334V13.3333C7.00726 13.3333 5.73549 12.8065 4.79781 11.8688C3.86013 10.9312 3.33334 9.6594 3.33334 8.33331C3.33334 7.00723 3.86013 5.73546 4.79781 4.79778C5.73549 3.8601 7.00726 3.33331 8.33334 3.33331H16.6667V4.99998H14.1667V17.5H12.5V4.99998H10ZM8.33334 4.99998C7.44929 4.99998 6.60144 5.35117 5.97632 5.97629C5.3512 6.60141 5.00001 7.44926 5.00001 8.33331C5.00001 9.21737 5.3512 10.0652 5.97632 10.6903C6.60144 11.3155 7.44929 11.6666 8.33334 11.6666V4.99998Z" fill="#212121"/></g><defs><clipPath id="clip0_53_22"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>

      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 1 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }" title="Заголовок 1">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_53_8)"><path d="M10.8333 16.6666H9.16666V10.8333H3.33332V16.6666H1.66666V3.33331H3.33332V9.16665H9.16666V3.33331H10.8333V16.6666ZM17.5 6.66665V16.6666H15.8333V8.50331L14.1667 8.94998V7.22498L16.25 6.66665H17.5Z" fill="#212121"/></g><defs><clipPath id="clip0_53_8"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>

      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 2 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }" title="Заголовок 2">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_53_7)"><path d="M3.33332 3.33331V9.16665H9.16666V3.33331H10.8333V16.6666H9.16666V10.8333H3.33332V16.6666H1.66666V3.33331H3.33332ZM15.4167 6.66665C17.1425 6.66665 18.5417 8.06581 18.5417 9.79165C18.5417 10.5058 18.3017 11.165 17.8983 11.6916L17.775 11.8416L15.0283 15H18.3333V16.6666H12.5V15.37L16.5167 10.7483C16.74 10.4925 16.875 10.1575 16.875 9.79165C16.875 8.98665 16.2217 8.33331 15.4167 8.33331C14.6517 8.33331 14.0242 8.92248 13.9633 9.67165L13.9583 9.79165H12.2917C12.2917 8.06581 13.6908 6.66665 15.4167 6.66665Z" fill="#212121"/></g><defs><clipPath id="clip0_53_7"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 3 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }" title="Заголовок 3">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_53_6)"><path d="M18.3334 6.66665L18.3317 8.33331L16.2442 10.7358C17.5692 11.0983 18.5417 12.3108 18.5417 13.75C18.5417 15.4758 17.1425 16.875 15.4167 16.875C13.895 16.875 12.6275 15.7875 12.3484 14.3475L13.985 14.0291C14.115 14.7008 14.7067 15.2083 15.4167 15.2083C16.2217 15.2083 16.875 14.555 16.875 13.75C16.875 12.945 16.2217 12.2916 15.4167 12.2916C15.1784 12.2916 14.9534 12.3491 14.755 12.45L13.6659 11.1608L16.125 8.33331H12.5V6.66665H18.3334ZM3.33335 3.33331V9.16665H9.16669V3.33331H10.8334V16.6666H9.16669V10.8333H3.33335V16.6666H1.66669V3.33331H3.33335Z" fill="#212121"/></g><defs><clipPath id="clip0_53_6"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>

      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 4 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 4 }) }" title="Заголовок 4">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_53_9)"><path d="M10.8334 16.6666H9.16669V10.8333H3.33335V16.6666H1.66669V3.33331H3.33335V9.16665H9.16669V3.33331H10.8334V16.6666ZM18.3334 6.66665V13.3333H19.5834V15H18.3334V16.6666H16.6667V15H12.0834V13.8833L16.25 6.66665H18.3334ZM16.6667 9.27748L14.325 13.3333H16.6667V9.27748Z" fill="#212121"/>
</g><defs><clipPath id="clip0_53_9"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>

      </button>
      <!--<button @click="editor.chain().focus().toggleHeading({ level: 5 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 5 }) }">
        h5
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 6 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 6 }) }">
        h6
      </button>-->
      <span class="separator-line"></span> 
      <button @click="editor.chain().focus().toggleBulletList().run()" :class="{ 'is-active': editor.isActive('bulletList') }" title="Список">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_9634)"><path d="M8 4H21V6H8V4ZM4.5 6.5C4.10218 6.5 3.72064 6.34196 3.43934 6.06066C3.15804 5.77936 3 5.39782 3 5C3 4.60218 3.15804 4.22064 3.43934 3.93934C3.72064 3.65804 4.10218 3.5 4.5 3.5C4.89782 3.5 5.27936 3.65804 5.56066 3.93934C5.84196 4.22064 6 4.60218 6 5C6 5.39782 5.84196 5.77936 5.56066 6.06066C5.27936 6.34196 4.89782 6.5 4.5 6.5ZM4.5 13.5C4.10218 13.5 3.72064 13.342 3.43934 13.0607C3.15804 12.7794 3 12.3978 3 12C3 11.6022 3.15804 11.2206 3.43934 10.9393C3.72064 10.658 4.10218 10.5 4.5 10.5C4.89782 10.5 5.27936 10.658 5.56066 10.9393C5.84196 11.2206 6 11.6022 6 12C6 12.3978 5.84196 12.7794 5.56066 13.0607C5.27936 13.342 4.89782 13.5 4.5 13.5ZM4.5 20.4C4.10218 20.4 3.72064 20.242 3.43934 19.9607C3.15804 19.6794 3 19.2978 3 18.9C3 18.5022 3.15804 18.1206 3.43934 17.8393C3.72064 17.558 4.10218 17.4 4.5 17.4C4.89782 17.4 5.27936 17.558 5.56066 17.8393C5.84196 18.1206 6 18.5022 6 18.9C6 19.2978 5.84196 19.6794 5.56066 19.9607C5.27936 20.242 4.89782 20.4 4.5 20.4ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z" fill="#212121"/></g><defs><clipPath id="clip0_2_9634"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      <button @click="editor.chain().focus().toggleOrderedList().run()" :class="{ 'is-active': editor.isActive('orderedList') }" title="Нумерованный список">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_9657)"><path d="M8 4H21V6H8V4ZM5 3V6H6V7H3V6H4V4H3V3H5ZM3 14V11.5H5V11H3V10H6V12.5H4V13H6V14H3ZM5 19.5H3V18.5H5V18H3V17H6V21H3V20H5V19.5ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z" fill="#212121"/></g><defs><clipPath id="clip0_2_9657"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      
      <button @click="editor.chain().focus().toggleBlockquote().run()" :class="{ 'is-active': editor.isActive('blockquote') }" title="Цитата">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_9746)"><path d="M4.583 17.321C3.553 16.227 3 15 3 13.011C3 9.511 5.457 6.374 9.03 4.823L9.923 6.201C6.588 8.005 5.936 10.346 5.676 11.822C6.213 11.544 6.916 11.447 7.605 11.511C9.409 11.678 10.831 13.159 10.831 15C10.831 15.9283 10.4623 16.8185 9.80587 17.4749C9.1495 18.1312 8.25926 18.5 7.331 18.5C6.258 18.5 5.232 18.01 4.583 17.321V17.321ZM14.583 17.321C13.553 16.227 13 15 13 13.011C13 9.511 15.457 6.374 19.03 4.823L19.923 6.201C16.588 8.005 15.936 10.346 15.676 11.822C16.213 11.544 16.916 11.447 17.605 11.511C19.409 11.678 20.831 13.159 20.831 15C20.831 15.9283 20.4623 16.8185 19.8059 17.4749C19.1495 18.1312 18.2593 18.5 17.331 18.5C16.258 18.5 15.232 18.01 14.583 17.321V17.321Z" fill="#212121"/></g><defs><clipPath id="clip0_2_9746"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      <button @click="editor.chain().focus().setHorizontalRule().run()" title="Горизонтальный разделитель">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_9671)"><path d="M2 11H4V13H2V11ZM6 11H18V13H6V11ZM20 11H22V13H20V11Z" fill="#212121"/></g><defs><clipPath id="clip0_2_9671"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      <button @click="editor.chain().focus().setHardBreak().run()" title="Разрыв">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_9647)"><path d="M15 18H16.5C17.163 18 17.7989 17.7366 18.2678 17.2678C18.7366 16.7989 19 16.163 19 15.5C19 14.837 18.7366 14.2011 18.2678 13.7322C17.7989 13.2634 17.163 13 16.5 13H3V11H16.5C17.6935 11 18.8381 11.4741 19.682 12.318C20.5259 13.1619 21 14.3065 21 15.5C21 16.6935 20.5259 17.8381 19.682 18.682C18.8381 19.5259 17.6935 20 16.5 20H15V22L11 19L15 16V18ZM3 4H21V6H3V4ZM9 18V20H3V18H9Z" fill="#212121"/></g><defs><clipPath id="clip0_2_9647"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      <span class="separator-line"></span> 
      <button @click="editor.chain().focus().toggleCodeBlock().run()" :class="{ 'is-active': editor.isActive('codeBlock') }" title="Code block">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_10636)"><path d="M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3V3ZM4 5V19H20V5H4ZM20 12L16.464 15.536L15.05 14.121L17.172 12L15.05 9.879L16.464 8.464L20 12ZM6.828 12L8.95 14.121L7.536 15.536L4 12L7.536 8.464L8.95 9.88L6.828 12ZM11.244 17H9.116L12.756 7H14.884L11.244 17Z" fill="#212121"/></g><defs><clipPath id="clip0_2_10636"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      <button @click="editor.chain().focus().toggleCode().run()" :disabled="!editor.can().chain().focus().toggleCode().run()" :class="{ 'is-active': editor.isActive('code') }" title="code">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_9853)"><path d="M16.95 8.46399L18.364 7.04999L23.314 12L18.364 16.95L16.95 15.536L20.485 12L16.95 8.46399ZM7.05 8.46399L3.515 12L7.05 15.536L5.636 16.95L0.685997 12L5.636 7.04999L7.05 8.46399V8.46399Z" fill="#212121"/></g><defs><clipPath id="clip0_2_9853"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      <button @click="showsrc" title="Source code" :class="{ 'is-active': src }">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_9807)"><path d="M4 18V14.3C4 13.9022 3.84196 13.5206 3.56066 13.2393C3.27936 12.958 2.89782 12.8 2.5 12.8H2V11.2H2.5C2.69698 11.2 2.89204 11.1612 3.07403 11.0858C3.25601 11.0104 3.42137 10.8999 3.56066 10.7607C3.69995 10.6214 3.81044 10.456 3.88582 10.274C3.9612 10.092 4 9.89698 4 9.7V6C4 5.20435 4.31607 4.44129 4.87868 3.87868C5.44129 3.31607 6.20435 3 7 3H8V5H7C6.73478 5 6.48043 5.10536 6.29289 5.29289C6.10536 5.48043 6 5.73478 6 6V10.1C6.0001 10.521 5.86735 10.9313 5.62064 11.2725C5.37393 11.6136 5.02586 11.8682 4.626 12C5.02586 12.1318 5.37393 12.3864 5.62064 12.7275C5.86735 13.0687 6.0001 13.479 6 13.9V18C6 18.2652 6.10536 18.5196 6.29289 18.7071C6.48043 18.8946 6.73478 19 7 19H8V21H7C6.20435 21 5.44129 20.6839 4.87868 20.1213C4.31607 19.5587 4 18.7956 4 18V18ZM20 14.3V18C20 18.7956 19.6839 19.5587 19.1213 20.1213C18.5587 20.6839 17.7956 21 17 21H16V19H17C17.2652 19 17.5196 18.8946 17.7071 18.7071C17.8946 18.5196 18 18.2652 18 18V13.9C17.9999 13.479 18.1327 13.0687 18.3794 12.7275C18.6261 12.3864 18.9741 12.1318 19.374 12C18.9741 11.8682 18.6261 11.6136 18.3794 11.2725C18.1327 10.9313 17.9999 10.521 18 10.1V6C18 5.73478 17.8946 5.48043 17.7071 5.29289C17.5196 5.10536 17.2652 5 17 5H16V3H17C17.7956 3 18.5587 3.31607 19.1213 3.87868C19.6839 4.44129 20 5.20435 20 6V9.7C20 10.0978 20.158 10.4794 20.4393 10.7607C20.7206 11.042 21.1022 11.2 21.5 11.2H22V12.8H21.5C21.1022 12.8 20.7206 12.958 20.4393 13.2393C20.158 13.5206 20 13.9022 20 14.3V14.3Z" fill="#212121"/></g><defs><clipPath id="clip0_2_9807"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      <span class="separator-line"></span> 
      <button @click="editor.chain().focus().undo().run()" :disabled="!editor.can().chain().focus().undo().run()" title="undo">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_8702)"><path d="M5.828 6.9998L8.364 9.5358L6.95 10.9498L2 5.9998L6.95 1.0498L8.364 2.4638L5.828 4.9998H13C15.1217 4.9998 17.1566 5.84266 18.6569 7.34295C20.1571 8.84324 21 10.8781 21 12.9998C21 15.1215 20.1571 17.1564 18.6569 18.6567C17.1566 20.157 15.1217 20.9998 13 20.9998H4V18.9998H13C14.5913 18.9998 16.1174 18.3677 17.2426 17.2424C18.3679 16.1172 19 14.5911 19 12.9998C19 11.4085 18.3679 9.88238 17.2426 8.75716C16.1174 7.63195 14.5913 6.9998 13 6.9998H5.828Z" fill="#212121"/></g><defs><clipPath id="clip0_2_8702"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      
      <button @click="editor.chain().focus().redo().run()" :disabled="!editor.can().chain().focus().redo().run()" title="redo">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_8678)"><path d="M18.172 6.9998H11C9.4087 6.9998 7.88258 7.63195 6.75736 8.75716C5.63214 9.88238 5 11.4085 5 12.9998C5 14.5911 5.63214 16.1172 6.75736 17.2424C7.88258 18.3677 9.4087 18.9998 11 18.9998H20V20.9998H11C8.87827 20.9998 6.84344 20.157 5.34315 18.6567C3.84285 17.1564 3 15.1215 3 12.9998C3 10.8781 3.84285 8.84324 5.34315 7.34295C6.84344 5.84266 8.87827 4.9998 11 4.9998H18.172L15.636 2.4638L17.05 1.0498L22 5.9998L17.05 10.9498L15.636 9.5358L18.172 6.9998Z" fill="#212121"/></g><defs><clipPath id="clip0_2_8678"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
    </div>
  </div>
  <editor-content class="custom-editor-body" :class="{'small-body':small}" :editor="editor" v-if="!src"/>
  <textarea class="src-code" @input="updateHTML" rows="10" :value="html" v-else></textarea>
</template>

<script>
  import StarterKit from '@tiptap/starter-kit'
  import Placeholder from '@tiptap/extension-placeholder'
  import { Editor, EditorContent } from '@tiptap/vue-3'

  export default {
    components: {
      EditorContent,
    },
    props: {
      modelValue: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      small: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:modelValue'],
    data() {
      return {
        editor: null,
        html: '',
        src: false
      }
    },
    methods:{
      showsrc(){
        this.src = !this.src
      },
      updateHTML(e){
        let value = e.target.value;
        this.editor.commands.setContent(value, false);
        this.html = value
        this.$emit('update:modelValue', value);
      }
    },
    watch: {

      modelValue(value) {
        // HTML
        const isSame = this.editor.getHTML() === value;
        // JSON
        // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)
        if (isSame) {
          return
        }
        this.editor.commands.setContent(value, false);
        this.html = value
      },
    },
    mounted() {
      this.editor = new Editor({
                                 extensions: [
                                   StarterKit,
                                   Placeholder.configure({placeholder: this.placeholder ? this.placeholder : this.$static('edtrr.placeholder', 'Введите текс сюда...')}),
                                 ],
                                 content: this.modelValue,
                                 onUpdate: () => {
                                   // HTML
                                   this.$emit('update:modelValue', this.editor.getHTML());
                                   this.html = this.editor.getHTML();
                                   // JSON
                                   // this.$emit('update:modelValue', this.editor.getJSON())
                                 },
                               });
      this.html = this.modelValue
    },
    beforeUnmount() {
      this.editor.destroy()
    },
  }
</script>

<style lang="scss">
  .src-code{ 
    width: 100%;
    background: transparent;
    border: none;
    resize: none;
  }
  .ProseMirror p.is-editor-empty:first-child::before {
    content: attr(data-placeholder);
    float: left;
    color: #adb5bd;
    pointer-events: none;
    height: 0;
  }
  /* Basic editor styles */
  .separator-line{
    position: relative;
    display: block;
    width: 1px;
    height: 100%;
    opacity: 0.1;
    margin: 0 10px;
    background-color: #000;
  }
  .custom-editor-body{
    flex: 1 1 auto;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 15px;
    -webkit-overflow-scrolling: touch;
    height: 200px;
    &.small-body{
      height: 150px;
    }
  }
  .custom-editor-header{
    padding: 5px;
    &.small-header{
      .separator-line{
        margin: 0 9px 0 6px;
        height: 28px;
        top: -2px;
      }

      button{
        width: 28px;
        height: 28px;
        margin-bottom: 3px;
        svg{
          width: 17px;
          height: 17px;
        }
      }
      .custom-editor-header-holder{
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        justify-content: flex-start;
        -webkit-justify-content: flex-start;
        height: auto;
        padding: 5px;
      }
    }
    .custom-editor-header-holder{
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.15);
      width: fit-content;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      padding: 0px 15px;
      border-radius: 5px;
      height: 55px;
      background-color: #fff;
    }

    button{
      background-color: transparent;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      justify-content:center;
      -moz-justify-content:center;
      -webkit-justify-content:center;
      border-radius: 35px;
      -webkit-border-radius: 35px;
      -moz-border-radius: 35px;
      width: 36px;
      height: 36px;
      margin-right: 5px;
      border: 0;
      cursor: pointer;
      padding: 0;
      position: relative;
      transition: all .2s cubic-bezier(0.165,0.84,0.44,1);
      -webkit-transition: all .2s cubic-bezier(0.165,0.84,0.44,1);
      color: #212121;
      &:hover{
        background-color: #e9e9e9;
      }
      &.is-active {
        background-color: #212121;
        &:hover{
          background-color: #212121;
        }
        path{
          fill:#FFF;
        }
      }

    }
  }
  .ProseMirror:focus{
    outline:none;
  }
  .ProseMirror {
    > * + * {
      margin-top: 0.75em;
    }
    ul,
    ol {
      padding: 0 1rem;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      line-height: 1.1;
    }
    code {
      background-color: rgba(#616161, 0.1);
      color: #616161;
    }
    pre {
      background: #0D0D0D;
      color: #FFF;
      font-family: 'JetBrainsMono', monospace;
      padding: 0.75rem 1rem;
      border-radius: 0.5rem;
      code {
        color: inherit;
        padding: 0;
        background: none;
        font-size: 0.8rem;
      }
    }
    img {
      max-width: 100%;
      height: auto;
    }
    blockquote {
      padding-left: 1rem;
      border-left: 2px solid rgba(#0D0D0D, 0.1);
    }
    hr {
      border: none;
      border-top: 2px solid rgba(#0D0D0D, 0.1);
      margin: 2rem 0;
    }
  }
</style>